import React from "react";
import AdminShell from "../components/AdminShell";
import MembersPanel from "../components/MembersPanel";

/**
 * AdminMembers — deep-link entry point for the Members directory.
 *
 * The same panel is mounted on /admin (AdminHome) so the founder
 * sees fresh signups the moment they land. This page exists for
 * direct links + sidebar nav, with a touch more vertical breathing
 * room than the home page provides.
 */
const AdminMembers = () => (
  <AdminShell
    eyebrow="Community"
    title="Members"
    subtitle="Everyone who's signed up plus the people you've personally invited."
  >
    <MembersPanel />
  </AdminShell>
);

export default AdminMembers;
